import crud from './common/CrudService';
import responseService from './common/ResponseService';

const API_BASE_URL = process.env.API_URL || 'http://127.0.0.1:8000';
const API_PREFIX = process.env.API_PREFIX || 'api/v1';
const chatsNotLabelledCRUD = crud(API_BASE_URL, API_PREFIX, ['chats/not-labelled/']);

const ChatsService = {
  getChatsNotLabelled: (skip, limit, labelMode, selectedLabel, showLabelled, selectedLanguage, seed) => {
    console.log('ALL: ', skip, limit, labelMode, selectedLabel, showLabelled, selectedLanguage, seed);
    const params = {
      limit,
    };
    if (skip) params['skip'] = skip;
    if (labelMode) params['labelMode'] = labelMode;
    if (selectedLabel) params['selectedLabel'] = selectedLabel;
    if (showLabelled) params['show_labelled'] = showLabelled;
    if (selectedLanguage) params['selected_language'] = selectedLanguage;
    if (seed) params['seed'] = seed;
    return responseService.handle(chatsNotLabelledCRUD.list(params));
  },
  exportChatContexts: async (contextKey, dateRange) => {
    const params = {
      contextKey,
      startDate: dateRange[0],
      endDate: dateRange[1],
    };

    try {
      const chatContextsCRUD = crud(API_BASE_URL, API_PREFIX, ['chats/contexts/export']);
      // Make the request with responseType: 'blob' to handle file downloads
      const response = await chatContextsCRUD.list(params, { responseType: 'blob' });
      const blob = await response.blob();

      // Create a blob from the response data
      // const blob = new Blob([response.data], { type: 'text/csv' });

      // Create a download link and trigger the download
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = `chat_contexts_${contextKey}_${dateRange[0]}_${dateRange[1]}.csv`;
      document.body.appendChild(a);
      a.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return { success: true };
    } catch (error) {
      return responseService.handle(Promise.reject(error));
    }
  },

  updateMessageLangLabel: (message_id, lang) => {
    const messageLangLabelCRUD = crud(API_BASE_URL, API_PREFIX, ['chats/message/lang']);
    const params = {
      message_id,
      lang,
    };
    return responseService.handle(messageLangLabelCRUD.list(params));
  },
};

export default ChatsService;
